import React from 'react';

export const CustomChip = props => {
    const {customChipKey, value, className} = props;
    return (
        <div key={customChipKey} className={className}>{value}</div>
    );
};